import LRUCache from 'lru-cache'

let cache = null

export function useCache(ttl = CACHE_TTL) {

    if ( !cache ) {
        cache = new LRUCache({
            maxAge: ttl,
            max: 0
        })
    }

    cache.clear = (key) => {
        cache.keys().forEach(cached => {
            if ( cached.includes(key) ) {
                cache.del(cached)
            }
        })
    }

    return cache
}

export const CACHE_TTL = 60 * 1000